import types from './mainTypes'

const setMainAppInitialized = (isAppInitialized: boolean) => ({ type: types.MAIN_SET_APP_INITIALIZED, isAppInitialized })

const mainActions = {
    setMainAppInitialized, // Установка, что приложение проинициализированно
}

export default mainActions